import { BasespaceFormArray, BasespaceFormProperties } from "../bs-app-launch-form-control";
import { BsAppLaunchFieldSetControlComponent } from "./bs-app-launch-field-set-control.component";

export interface FieldSetFormProperties extends BasespaceFormProperties<BsAppLaunchFieldSetControlComponent> {
    fields: any[];
    isCollapsible: boolean; // This doesn't feel like it has utility
    isOpen: boolean;
}

// Reference docs: https://dagobah-developer.cloud-test.illumina.com/docs/content/documentation/apptools/formbuilder-overview#FieldSet
// Reference class: src/Cloud.FormBuilder/Models/FieldSet.cs
export class FieldSetFormControl extends BasespaceFormArray<BsAppLaunchFieldSetControlComponent> implements FieldSetFormProperties {
    fields: any[];
    isCollapsible: boolean;
    isOpen: boolean;
    
    constructor(
        data: FieldSetFormProperties
    ) {
        const { id, componentReference, label, helpText, fields, isCollapsible, isOpen, formControlType } = data;
        super({ id, componentReference, label, helpText, formControlType });

        this.fields = fields || [];
        this.isCollapsible = isCollapsible || false;
        this.isOpen = isOpen || false;

    }

}